import React from "react";
import { View, StyleSheet, TouchableWithoutFeedback } from "react-native";
import Text from "@components/AppText";
import ProductRequest from "@assets/svg/ProductRequest";
import Caret from "@assets/svg/Caret";
import colors from "@constants/color";
import { REQUEST_PRODUCT } from "../constants/analyticsEvents";
import t from "../constants/localization";

const PATH = "components/RequestProduct";

const RequestProduct = ({ navigateTo = () => {}, fromScreen = "" }) => {
  return (
    <TouchableWithoutFeedback
      onPress={navigateTo}
      eventName={REQUEST_PRODUCT}
      eventPayload={{
        screen: fromScreen,
      }}
    >
      <View style={styles.productRequestContainer}>
        <ProductRequest />
        <View>
          <View>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text
                style={{
                  fontWeight: "bold",
                  paddingVertical: 10,
                  fontSize: 18,
                  color: colors.white,
                }}
                fontType="content1"
              >
                {t(`${PATH}/whatWereYouSearching`)}
              </Text>
              <Caret
                strokeWidth={0.6}
                width={24}
                height={24}
                strokeColor={colors.white}
              />
            </View>
          </View>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  productRequestContainer: {
    margin: 15,
    marginBottom: 40,
    borderRadius: 6,
    flex: 2,
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    paddingVertical: 20,
    backgroundColor: "rgba(0, 116, 201, 0.7)",
  },
});

export default RequestProduct;
